import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const postNotify = (data) => axios.post(`${API}/notify`, data).then((r) => r.data);
export const postContact = (data) => axios.post(`${API}/contact`, data).then((r) => r.data);
